import { ModelBase } from 'store/model-base';

export class CmsContactBar extends ModelBase {
    public static storeName: string = 'cmsContactBar';
    public residential: CmsContactBarData;
    public commerical: CmsContactBarData;
}
